import SEOxProjectSettings from './SEOxProjectSettings.container';

export default SEOxProjectSettings;
